export default function stripHTMLFromText(text: string) {
  const regexForStripHTML = /(<([^>]+)>)/gi;
  const stripContent = text?.replace?.(regexForStripHTML, '') ?? text;
  return stripContent;
}
